


















































import {Vue, Component} from 'vue-property-decorator';
import {Title} from '@/components/Title';
import {Pagination} from '@/components/Pagination';
import {NewsTile} from '@/components/NewsTile';
import {mapGetters, mapActions} from 'vuex';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'NewsList',
  components: {
    NewsTile, Pagination,
    Title, VLazyImage,
  },
  created() {
    this.fetchNews();
    this.fetchTranslation();
  },
  data() {
    return {
      activeFilter: 'all',
      numberOnPage: 10,
    };
  },
  computed: {
    ...mapGetters('news', ['titlePage', 'headerBgImg', 'filters', 'allNews', 'promoText', 'paginationBtnText']),
    nextPageLink() {
      return this.allNews.next ? this.allNews.next : '';
    },
  },
  methods: {
    ...mapActions('news', ['fetchTranslation', 'fetchNews', 'getNewPage', 'getNextPage']),

    filterNews(filter) {
      this.activeFilter = filter;
      this.updateActualPage(1);
      this.$emit('changeFilter');
    },

    srcImg(img) {
      return img && `${img[3600]}` || '';
    },

    srcImgPlaceholder(img) {
      return img && `${img[400]}`;
    },

    srcSet(img) {
      return img && `${img[400]} 400w, ${img[800]} 800w,
      ${img[1300]} 1300w, ${img[1900]} 1900w, ${img[3600]} 3600w`;
    },

    updateActualPage(pageNumber) {
      this.getNewPage(this.formattingQueryString(this.activeFilter, pageNumber.page));
    },

    addNewsToPage(pageNumber) {
      this.getNextPage(this.formattingQueryString(this.activeFilter, pageNumber.page));
    },

    formattingQueryString(filter, page) {
      const filterType = filter === 'promo' ? 'promo=True'
          : filter === 'news' ? 'promo=False' : '';
      const actualPage = page ? `page=${page}` : 'page=1';
      return actualPage === '' ? `?${filterType}`
          : filterType === '' ? `?${actualPage}`
              : `?${actualPage}&${filterType}`;
    },
  },
})
export default class NewsList extends Vue {
}
